import { inter } from "../fonts/inter";
import { motion } from "framer-motion";
import HeroBackground from "../components/background/HeroBackground";
import React from "react";
import AnimatedTitle from "../animations/AnimatedTitle";
import { bitcountPropSingle } from "../fonts/bitcount.js";
import AudioPlayer from "../components/AudioPlayer.tsx";

const Hero = () => {
  return (
    <motion.section
      className="relative z-10 flex h-[100vh] w-full justify-center"
      id="home"
      initial="initial"
      animate="animate"
    >
      <HeroBackground />
      <div className="mt-10 flex flex-col items-center justify-center sm:mt-0">
        <div
          className={`relative flex flex-col items-center justify-center ${inter.className} pointer-events-auto`}
        >
          <AnimatedTitle
            text={"Mint Mind"}
            className={`mb-1 text-left text-[40px] font-bold leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-[45px] md:mb-16 md:text-[60px] lg:text-[80px] ${bitcountPropSingle.className}`}
            wordSpace={"mr-[10px]"}
            charSpace={"mr-[0.001em]"}
          />
          <AudioPlayer />
        </div>
      </div>
    </motion.section>
  );
};

export default Hero;
